export default {
  maxvalue: {
    bind(el, binding) {
      let max_chars = binding.expression;
      let handlerInput = (e) => {
        if (parseInt(e.target.value) > parseInt(max_chars)) {
          e.target.value = max_chars;
          e.target.dispatchEvent(new CustomEvent("input"));
        }
      };
      el.addEventListener("input", handlerInput);
    },
  },

  maxlength: {
    bind(el, binding) {
      let max_chars = binding.expression;
      let handlerInput = (e) => {
        if (e.target.value.length > max_chars) {
          e.target.value = e.target.value.substr(0, max_chars);
          e.target.dispatchEvent(new CustomEvent("input"));
        }
      };
      el.addEventListener("input", handlerInput);
    },
  },
};
